module.exports = __webpack_public_path__ + "static/media/chevron.f28011ca.svg";